/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PollReportQuestion'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PollReportQuestion'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PollReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PollReportQuestion);
  }
}(this, function(ApiClient, PollReportQuestion) {
  'use strict';




  /**
   * The PollReport model module.
   * @module model/PollReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>PollReport</code>.
   * @alias module:model/PollReport
   * @class
   */
  var exports = function() {
    var _this = this;











  };

  /**
   * Constructs a <code>PollReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/PollReport} obj Optional instance to populate.
   * @return {module:model/PollReport} The populated <code>PollReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('PollCategory')) {
        obj['PollCategory'] = ApiClient.convertToType(data['PollCategory'], 'Integer');
      }
      if (data.hasOwnProperty('PollIdentifier')) {
        obj['PollIdentifier'] = ApiClient.convertToType(data['PollIdentifier'], 'Integer');
      }
      if (data.hasOwnProperty('Title')) {
        obj['Title'] = ApiClient.convertToType(data['Title'], 'String');
      }
      if (data.hasOwnProperty('PollTitle')) {
        obj['PollTitle'] = ApiClient.convertToType(data['PollTitle'], 'String');
      }
      if (data.hasOwnProperty('CreatedDateTime')) {
        obj['CreatedDateTime'] = ApiClient.convertToType(data['CreatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('TargetPeriodID')) {
        obj['TargetPeriodID'] = ApiClient.convertToType(data['TargetPeriodID'], 'Integer');
      }
      if (data.hasOwnProperty('IntroductionText')) {
        obj['IntroductionText'] = ApiClient.convertToType(data['IntroductionText'], 'String');
      }
      if (data.hasOwnProperty('Questions')) {
        obj['Questions'] = ApiClient.convertToType(data['Questions'], [PollReportQuestion]);
      }
      if (data.hasOwnProperty('IndicatorID')) {
        obj['IndicatorID'] = ApiClient.convertToType(data['IndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('WorkshopURL')) {
        obj['WorkshopURL'] = ApiClient.convertToType(data['WorkshopURL'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} PollCategory
   * @default 0
   */
  exports.prototype['PollCategory'] = 0;
  /**
   * @member {Integer} PollIdentifier
   * @default 0
   */
  exports.prototype['PollIdentifier'] = 0;
  /**
   * @member {String} Title
   * @default ''
   */
  exports.prototype['Title'] = '';
  /**
   * @member {String} PollTitle
   * @default ''
   */
  exports.prototype['PollTitle'] = '';
  /**
   * @member {Date} CreatedDateTime
   */
  exports.prototype['CreatedDateTime'] = undefined;
  /**
   * @member {Integer} TargetPeriodID
   * @default 0
   */
  exports.prototype['TargetPeriodID'] = 0;
  /**
   * @member {String} IntroductionText
   * @default ''
   */
  exports.prototype['IntroductionText'] = '';
  /**
   * @member {Array.<module:model/PollReportQuestion>} Questions
   */
  exports.prototype['Questions'] = undefined;
  /**
   * @member {Integer} IndicatorID
   * @default 0
   */
  exports.prototype['IndicatorID'] = 0;
  /**
   * @member {String} WorkshopURL
   * @default ''
   */
  exports.prototype['WorkshopURL'] = '';



  return exports;
}));


